window.addEventListener("DOMContentLoaded", () => {
    const seoText = document.querySelector('.seo-text2 .seo-text__text');
    const seoTextInner = seoText.querySelector('.metafield-rich_text_field');
    const btnToggle = document.querySelector('.seo-text2 .seo-text__read-more');
    const btnMore = btnToggle.innerHTML;
    const btnLess = btnToggle.dataset.hide;
    const seoTextChild1 = seoTextInner.children[0].offsetHeight;
    const seoTextChild2 = seoTextInner.children[1].offsetHeight;

    let maxHeight = seoTextChild1 + seoTextChild2 + 20;
    let fullHeight = 0;

    [...seoTextInner.children].forEach(element => {
        fullHeight = fullHeight + element.offsetHeight + 15;
    });
    seoText.style.maxHeight = `${maxHeight}px`;

    btnToggle.addEventListener('click', (e) => {
        e.currentTarget.innerHTML = ( e.currentTarget.innerHTML == btnMore) ? btnLess : btnMore;
        seoText.classList.toggle('active');
        if (seoText.classList.contains("active")) {
            seoText.style.maxHeight = `${fullHeight}px`;
        } else {
            seoText.style.maxHeight = `${maxHeight}px`;
        }
        seoText.setAttribute('aria-expanded', seoText.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
});
